import React from 'react';
import { LockIcon } from 'lucide-react';
import { Badge, BadgeTone } from './Badge';
const statusTone: Record<string, BadgeTone> = {
  Active: 'success',
  Locked: 'success',
  Draft: 'warning',
  Retired: 'neutral',
  Open: 'info',
  Calculated: 'neutral',
  Adjustment: 'warningLight',
  Manual: 'info',
  Skipped: 'neutral'
};
export function StatusBadge({
  status
}: {
  status: string;
}) {
  return <Badge tone={statusTone[status] ?? 'neutral'} icon={status === 'Locked' ? <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-873" data-mp="1q2u8bz5myct2" /> : undefined} data-id="element-872" data-mp="1l2ycwob07tp4">
      {status}
    </Badge>;
}